import { css } from '@emotion/react';

export default () => css`
  .blockly-editor {
    width: 500px;
    height: 500px;
  }

  /* La clase está en el mismo div de inyección */
  .injectionDiv.responsive-blockly {
    width: 500px !important;
    height: 500px !important;
  }

  /* El SVG ocupa todo dentro del injection div */
  .injectionDiv.responsive-blockly .blocklySvg {
    width: 100% !important;
    height: 100% !important;
  }
`;
